import React from 'react';
import { BriefcaseBusiness, Home, MessageCircle, Smartphone } from 'lucide-react';
import { NavLink } from 'react-router-dom';
import { useLanguage } from '../i18n/LanguageProvider';

const TabBar = () => {
  const { t } = useLanguage();
  const links = [
    { route: '/', label: 'Accueil', icon: Home, end: true },
    { route: '/business', label: 'Business', icon: BriefcaseBusiness },
    { route: '/appmobile', label: 'Nos applications', shortLabel: 'Applications', icon: Smartphone },
    { route: '/contact', label: 'Contact', icon: MessageCircle },
  ];

  return (
    <nav className="ws-tab-bar" aria-label={t('Navigation mobile')} data-no-i18n="true">
      {links.map(({ route, label, shortLabel, icon: Icon, end }) => (
        <NavLink key={route} to={route} end={end} className="ws-tab-bar__link" aria-label={t(label)}>
          <Icon size={20} aria-hidden="true" />
          <span>{t(shortLabel || label)}</span>
        </NavLink>
      ))}
    </nav>
  );
};

export default TabBar;
